import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "fieldsContainer"]
  
  connect() {
    // Optional: initialization code if needed
  }
  
  onChange() {
    const selectedFieldId = this.selectTarget.value
    
    if (selectedFieldId === "") {
      return
    }
    
    // Make the request using Turbo Stream
    fetch(`/custom_fields/${selectedFieldId}`, {
      method: "GET",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok")
      }
      
      // Disable the selected option
      const option = this.selectTarget.querySelector(`option[value="${selectedFieldId}"]`)
      if (option) {
        option.disabled = true
      }
      
      // Reset selection to empty option
      const defaultOption = this.selectTarget.querySelector("option[value='']")
      if (defaultOption) {
        defaultOption.selected = true
      }
      
      return response.text()
    })
    .then(html => {
      // Turbo will automatically process the stream and update the DOM
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")
      const streamElement = doc.querySelector("turbo-stream")
      if (streamElement) {
        document.body.appendChild(streamElement)
      }
    })
    .catch(error => console.error("Error fetching custom field:", error))
  }
}
